import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { Grid } from '@abyss/web/ui/Grid';
import { SelectInput } from '@abyss/web/ui/SelectInput';
import { DeleteButton } from '@src/components/global/DeleteButton';
import { EmployeeDetailController } from './EmployeeDetail.Controller';
import { DetailWrapper } from '@src/components/global/DetailWrapper';

export const EmployeeDetail = () => {
  const { form, pageData, Action, pageTop, params } =
    EmployeeDetailController();

  const departmentOptions = [
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Design', label: 'Design' },
    { value: 'HR', label: 'Human Resources' },
    { value: 'Finance', label: 'Finance' },
  ];

  return (
    <DetailWrapper
      data={pageData.detailResponse}
      form={form}
      formData={pageData.item}
      onSave={Action.Save}
    >
      <div ref={pageTop}>
        <Grid>
          <Grid.Col span={{ sm: 12, md: 6 }}>
            <TextInput
              label="Employee Name"
              model="name"
              maxLength={100}
              validators={{
                required: true,
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ sm: 12, md: 6 }}>
            <TextInput
              label="Email"
              model="email"
              maxLength={100}
              validators={{
                required: true,
                email: true,
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ sm: 12, md: 6 }}>
            <SelectInput
              label="Department"
              model="department"
              options={departmentOptions}
              validators={{
                required: true,
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ sm: 12, md: 6 }}>
            <TextInput
              label="Position"
              model="position"
              maxLength={100}
              validators={{
                required: true,
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ sm: 12, md: 6 }}>
            <TextInput
              label="Age"
              model="age"
              type="number"
              validators={{
                required: true,
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ sm: 12, md: 6 }}>
            <TextInput
              label="Salary"
              model="salary"
              type="number"
              validators={{
                required: true,
              }}
            />
          </Grid.Col>
        </Grid>
        {params?.id && params.id !== '0' && (
          <DeleteButton params={params} delete={Action.OnDeleteConfirm} />
        )}
      </div>
    </DetailWrapper>
  );
};
